import { IntakeNoteComprehensiveOverallInformation } from 'src/graphql.generated'
import { DateTime } from 'luxon'
import { IntakeNoteComprehensiveFormType } from '../IntakeNoteComprehensiveFormSchema'

type OverallInformationFormFields = Pick<
  IntakeNoteComprehensiveFormType,
  | 'FIRST_NAME'
  | 'LAST_NAME'
  | 'MEMBER_ID'
  | 'CALL_START_TIME'
  | 'CALL_END_TIME'
  | 'PROVIDER_NAME'
  | 'LICENSE_TYPE'
  | 'date'
>

export type OverallInformationFormPartial = Partial<OverallInformationFormFields>

export const mapOverallInformationToForm = (
  info?: IntakeNoteComprehensiveOverallInformation | null
): OverallInformationFormFields | Record<string, never> => {
  if (!info) return {}

  return {
    date: resolveDate(info),
    FIRST_NAME: info.firstName ?? '',
    LAST_NAME: info.lastName ?? '',
    MEMBER_ID: info.memberID ?? '',
    CALL_START_TIME: info.callStartTime ?? '',
    CALL_END_TIME: info.callEndTime ?? '',
    PROVIDER_NAME: info.providerName ?? '',
    LICENSE_TYPE: info.licenseType ?? '',
  }
}

function resolveDate(info: IntakeNoteComprehensiveOverallInformation) {
  return info.callStartTime
    ? DateTime.fromISO(info.callStartTime).toFormat('yyyy-MM-dd')
    : DateTime.now().toFormat('yyyy-MM-dd')
}
